import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetContingencyAuto: null,
    statusSetContingencyAuto: null,
    contingencyAuto: [],
    contingencyAutoConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setContingencyAuto (state, data) {
      state.contingencyAuto = data
    },
    setResponseUpdateContingencyAutoConfig (state, data) {
      state.statusSetContingencyAuto = data
    },
    setResponseGetContingencyAuto (state, data) {
      state.statusGetContingencyAuto = data
    },
    setResponseContingencyAutoMsg (state, data) {
      state.contingencyAutoConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getContingencyAuto ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        console.log(JSON.parse(atob(localStorage.getItem('uid'))).rol.trim);
        console.log('Desarrollador');

        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getContingencyAutoConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setContingencyAuto', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetContingencyAuto', true)
            commit('setResponseContingencyAutoMsg', 'Hubo un error obteniendo la configuración de contigencia automatica. Intentelo nuevamente.')
          } else {
            commit('setResponseGetContingencyAuto', false)
            commit('setResponseContingencyAutoMsg', 'Configuración de contigencia automatica consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetContingencyAuto', true)
          commit('setResponseContingencyAutoMsg', 'No pudo obtener  configuración de contigencia automatica. Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateContingencyAutoConfig ({ commit }, data) {
      const endpoint = '/api/updateContingencyAutoConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateContingencyAutoConfig', true)
              commit('setResponseContingencyAutoMsg', 'Hubo un error guardando la configuración de contigencia automatica. Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateContingencyAutoConfig', false)
              commit('setResponseContingencyAutoMsg', 'Configuración de cambio de contigencia automatica guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateContingencyAutoConfig', true)
          commit('setResponseContingencyAutoMsg', 'No pudo obtener información de la configuración de contigencia automatica.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateContingencyAutoConfig', data)
    },
    statusGetContingencyAuto ({ commit }, data) {
      commit('setResponseGetContingencyAuto', data)
    },
  },
}
